import { render, staticRenderFns } from "./lnk-simple-table.vue?vue&type=template&id=2a6eb99a&"
import script from "./lnk-simple-table.vue?vue&type=script&lang=js&"
export * from "./lnk-simple-table.vue?vue&type=script&lang=js&"
import style0 from "./lnk-simple-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports